import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { StateService, Transition } from '@uirouter/angular';
import { OccupationModel } from '@app/ps/models/occupation.model';
import { Restangular } from 'ngx-restangular';
import { ExpertModel } from '@app/ps/models/expert.model';
import { SwitchOption } from '@app/common/components/switch/switch.component';
import { AuthService } from '@app/common/services/auth.service';
import { BrandService } from "@app/common/services/brand.service";
import { OccupationSolutionTypeModel } from "@app/ps/models/occupation-solution-type.model";
import { ListService } from "@app/common/services/list.service";
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';

@Component({
  templateUrl: './update-occupation.component.html',
  styleUrls: ['./update-occupation.component.scss'],
})
export class UpdateOccupationComponent implements OnInit {
  @Input() titleId: number;
  @Input() parcelId: number;
  @Input() occupationId: number;
  @Input() constructionObjectId: number;

  public occupationTypeName: string;

  occupationObject: OccupationModel;
  public priceType: SwitchOption[];
  public priceUnit: SwitchOption[];
  public priorityOptions = [];
  public priorityHolder = { priorityIndex: null };
  public occupationSolutionTypeOptions: OccupationSolutionTypeModel[];
  private priceAssesment;
  private originalFinalSolutionTypeId: number;
  private originalFinalSolutionReasonCancellation: string;

  public occupationSolutionOptions = [
    {id: null, value: 'Jiný způsob řešení'},
    {id: 'permanentWithSolutionTypeUnderOneYear', value: 'Nájem do 1 roku'},
    {id: 'permanentWithSolutionTypeOverOneYear', value: 'Nájem nad 1 rok'},
  ];

  constructor(
    @Inject('$transition$')
    private transition: Transition,

    private stateService: StateService,
    private restangular: Restangular,
    private authService: AuthService,
    private brandService: BrandService,
    private listLoadService: ListService,
  ) {
    this.goToDetail = this.goToDetail.bind(this);
    this.update = this.update.bind(this);
    this.priceType = [
      {
        value: 'Cenový výměr ministerstva financí',
        id: 'F',
      },
      {
        value: 'Znalecký posudek',
        id: 'E',
      },
      {
        value: 'Jiný způsob',
        id: 'O',
      },
    ];

    this.priceUnit = [
      {
        value: 'Roční cena za metr čtvereční',
        id: 'A',
      },
      {
        value: 'Jednorázová cena',
        id: 'T',
      },
    ];
  }

  async ngOnInit() {
    await this.loadOccupationSolutionTypes();
    await this.loadOccupation();
  }

  public onRentalPriceTypeChange(newValue) {
    this.occupationObject.rentalPriceType = newValue;
    this.updateAssessment();
  }

  updateAssessment() {
    if (this.priceAssesment && this.occupationObject.rentalPriceType === 'F') {
        this.occupationObject.priceAssessmentYear = this.priceAssesment.year;
        this.occupationObject.priceAssessmentPrice = this.priceAssesment.prices.find(p => p.areaId === this.occupationObject.parcel.katuzeKod);
        this.occupationObject.priceAssessmentLandPrice = this.occupationObject.priceAssessmentPrice ? this.occupationObject.priceAssessmentPrice.price : null;
    }
  }

  async loadOccupationSolutionTypes() {

    this.occupationSolutionTypeOptions = await this.listLoadService.fetchResult(this.listLoadService.createList("occupation-solution-types", {
      limit: null,
    })).then((data) => {
      if (data.list && !data.list.length) return [];
      const type = this.authService.getActualProject().type;
      let list = data.list;
      if (type === 'ADDITIONAL') list = list.slice(0, 6);
      // TODO rozsireni pro typ akce 'INVEST'
      // else if (type === 'INVEST') list = list.slice(6);
      else list = [];

      return list.slice(1);
    })
  }

  async loadOccupation() {
    this.occupationObject = await this.restangular.one('occupations', this.occupationId).get({loadCollections: ['rentalExpert', 'priceAssessmentPrice']}).toPromise();
    this.priceAssesment = await this.restangular.all('price-assessments').all('list').customPOST().toPromise().then(r => {
      return r[r.length-1];
    });
    this.occupationObject.rentalPriceType = this.occupationObject.rentalPriceType || 'F';
    this.occupationObject.rentalPriceUnit = this.occupationObject.rentalPriceUnit || 'A';
    if (this.occupationObject.solutionType === 'permanentWithSolutionUnderOneYear') {
      this.occupationObject.rentalLength = this.occupationObject.rentalLength || 12;
    }
    this.occupationObject.solutionType = this.occupationObject.solutionType || null;
    this.occupationObject.priorityIndex = this.occupationObject.priorityIndex || 0;

    this.originalFinalSolutionTypeId = this.occupationObject.finalSolutionType ? this.occupationObject.finalSolutionType.id : null;
    this.originalFinalSolutionReasonCancellation = this.occupationObject.finalSolutionReasonCancellation || null;

    this.occupationTypeName = this.occupationLongerThanOneYear() ? 'Dočasný zábor nad 1 rok' : (this.occupationShorterThanOneYear() ? 'Dočasný zábor do 1 roku' : this.occupationObject.zabtyptx);
    this.updateAssessment();

    const project = this.authService.getActualProject();
    if (project && project.occupationsPriority && project.occupationsPriority.enabled) {
      this.priorityOptions = project.occupationsPriority.categories
        .map((c: any, i: number) => ({ id: i, name: c.name }));
      this.priorityHolder.priorityIndex = this.priorityOptions
        .find(o => o.id === (this.occupationObject.priorityIndex ? this.occupationObject.priorityIndex : 0)) || this.priorityOptions[0];
    }
  }

  goToDetail() {
      if (this.stateService.params.redirect) {
        this.stateService.go(this.stateService.params.redirect, { parcel: this.stateService.params.parcel }  );
      } else {
        this.stateService.go('^', { tab: this.titleId || this.constructionObjectId ? 'parcels' : 'occupations'  });
      }
  }

  async update() {
    this.occupationObject.priorityIndex = this.priorityHolder.priorityIndex ? this.priorityHolder.priorityIndex.id : 0;

    const finalSolutionTypeChanged = (this.occupationObject.finalSolutionType ? this.occupationObject.finalSolutionType.id : null) !== this.originalFinalSolutionTypeId;
    const cancellationReasonChanged = (this.occupationObject.finalSolutionReasonCancellation || null) !== this.originalFinalSolutionReasonCancellation;
    if (finalSolutionTypeChanged || cancellationReasonChanged) {
      this.occupationObject.finalSolutionState = FinalSolutionStateEnum.PENDING;
    }

    await (<any>this.occupationObject)
          .put().toPromise();
    this.goToDetail();
  }

  onChangeExpert(expert: ExpertModel) {
    this.occupationObject.rentalExpert = expert;
  }

  isSolutionType(): boolean {
    return ((
      this.occupationObject.zabtyp == 3 || this.occupationObject.zabtyp == 7 ||
      this.occupationObject.zabtyp == 12 || this.occupationObject.zabtyp == 121 ||
      this.occupationObject.zabtyp == 122) && !this.brandService.isVisible('mpv'))
  }

  isChangeFinalSolutionType(): boolean {
    return this.brandService.isVisible('mpv') &&
      this.authService.getActualProject().type === 'ADDITIONAL' &&
      this.occupationObject.occupationType.category === 'permanent' &&
      (this.occupationObject.finalSolutionType.key !== 'CANCELLED' || Boolean(this.occupationObject.finalSolutionReasonCancellation)) &&
      this.occupationObject.finalSolutionType.id !== 1;
  }

  isValid() {
    return this.isChangeFinalSolutionType() &&
     (!this.occupationObject.solutionType && !this.occupationLongerThanOneYear() && !this.occupationShorterThanOneYear()) ||
     (this.occupationObject.rentalPriceType && this.occupationObject.rentalLength > 0 &&
       (
        ((this.occupationLongerThanOneYear() || this.occupationObject.solutionType === 'permanentWithSolutionTypeOverOneYear') && this.occupationObject.rentalLength > 12) ||
        ((this.occupationShorterThanOneYear() || this.occupationObject.solutionType === 'permanentWithSolutionTypeUnderOneYear') && this.occupationObject.rentalLength <= 12)
       ) &&
       (
        (this.occupationObject.rentalPriceType === 'F' && this.occupationObject.priceAssessmentYear && this.occupationObject.priceAssessmentLandPrice) ||
        (this.occupationObject.rentalPriceType === 'E' && this.occupationObject.rentalExpertOpinionNumber && this.occupationObject.rentalExpertOpinionDate && this.occupationObject.rentalExpert && this.occupationObject.priceAssessmentLandPrice) ||
        (this.occupationObject.rentalPriceType === 'O' && this.occupationObject.rentalOtherPriceSource && ((this.occupationObject.rentalPriceUnit === 'T' && this.occupationObject.totalRentPrice >= 0) || (this.occupationObject.rentalPriceUnit === 'A' && this.occupationObject.priceAssessmentLandPrice >= 0)))
      )
    );
  }

  occupationLongerThanOneYear() {
    return this.occupationObject.occupationType.category === 'overOneYear';
  }

  occupationShorterThanOneYear() {
    return this.occupationObject.occupationType.category === 'underOneYear';
  }

  onOccupationSolutionTypeOptionSelected(option: OccupationSolutionTypeModel) {
    this.occupationObject.finalSolutionReasonCancellation = null;
    this.occupationObject.finalSolutionType = option;
  }
}

